import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../../../contexts/AuthContext'
import TablaGrupos from "./TablaGrupos";
import GruposCreate from "./GruposCreate";
import axios from "axios";
import { Table, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import Header from "../../../../layout/Header/Header";

function ListadoGrupos() {
  const { user } = useContext(AuthContext);
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const [grupos, setGrupos] = useState([]);

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  useEffect(() => {
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
  },[]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_clientes  ?(
      <div className="container">
        <div className="card col-12">
                  <div className="page-header">
                    <div>
                      <h3 className="page-title">
                        <i className="fas fa-user-tie" style={{ marginRight: 8, color: "#3b82f6" }} />
                        Zonas
                      </h3>
                    </div>
                    <div className="page-actions">
                      <Button size="sm" color="success" onClick={toggleCreate}>
                        <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Zona
                      </Button>
                    </div>
                  </div>
                  <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                    <thead>
                      <tr>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grupos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return (
                          <tr>
                            <TablaGrupos name={a.name} _id={a._id} is_active={a.is_active} />
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
        </div>
      </div>
      ): undefined }

      {/* Modal de alta */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8 }} />
          Nueva Zona
        </ModalHeader>
        <ModalBody>
          <GruposCreate />
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoGrupos;
